import type { ContentStatus } from '@zuruflex/types';

/** The public site, for "view live" links. */
export const webUrl: string = (import.meta.env.VITE_WEB_URL as string | undefined) ?? '';

/** A title as an address: "Cookie policy" → "cookie-policy". */
export function slugify(title: string): string {
  return title
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export const STATUS_VARIANT: Record<ContentStatus, 'success' | 'warning' | 'default' | 'outline'> = {
  LIVE: 'success',
  LIVE_WITH_CHANGES: 'warning',
  DRAFT_ONLY: 'default',
  UNPUBLISHED: 'outline',
  SCHEDULED: 'warning',
};
